<template>
  <section class="claim-page static-page">
    <div class="columns is-centered is-fullheight">
      <div class="static-page-title-container">
        <h1>Welcome to the PedalSure Data Protection Centre</h1>
      </div>
    </div>
    <div class="static-page-illustration">
      <img
        src="~/assets/images/illustrations/Policy-page.svg"
        alt="Contact Permissions"
      />
    </div>
    <div class="container">
      <div>
        <a
          target="_blank"
          href="/documents/november_2026/Privacy_Policy_11-2026.pdf"
          style="
            margin: 50px auto;
            display: flex;
            width: 200px;
            flex-direction: column;
            text-align: center;
          "
        >
          <img
            src="~/assets/images/icons/blue/terms-and-conditions.svg"
            class="icon alt"
            alt="pedalsure icon"
            style="margin: 0 auto"
          />

          <span> Privacy Policy </span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import { buildSocialMeta } from '@/helpers/social-meta'

const CANONICAL_PATH = '/contact-permissions'

export default {
  name: 'ContactPermissionsPage',
  head() {
    const title = 'PedalSure'
    const description = 'PedalSure'
    return {
      title,
      meta: [
        { hid: 'description', name: 'description', content: description },
        ...buildSocialMeta({
          title,
          description,
          path: CANONICAL_PATH,
        }).meta,
      ],
    }
  },
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 30px;
  .sub-title {
    font-size: 1.6rem;
    line-height: 1.8rem;
    // font-family: $family-light;
    font-family: $family-regular;
    @include desktop {
      font-size: 2rem;
      line-height: 2.1rem;
    }
  }
  .icon-container {
    text-align: center;
    margin: 20px 0;
    img {
      width: 70px;
      height: 70px;
    }
  }
  .our-promise {
    max-width: 450px;
    margin: 20px auto;
    font-family: $family-regular;
    text-align: center;
    font-size: 0.9rem;
    line-height: 1rem;
    color: $ps-gray;
    @include desktop {
      font-size: 1rem;
      line-height: 1.2rem;
    }
  }
  .how-process-title {
    margin: 70px 0 50px;
  }
  .how-process {
    text-align: center;
    margin-bottom: 40px;
    padding-bottom: 40px;
    @include desktop {
      margin-bottom: 40px;
      padding-bottom: 70px;
    }
    border-bottom: 1px solid $ps-gray;
    .subtitle {
      margin: 10px 0;
      display: block;
    }
    img {
      width: 60px;
      height: 60px;
      display: block;
      margin: 0 auto;
    }
    .info {
      line-height: 1rem;
      font-family: $family-light;
      max-width: 200px;
      margin: 0 auto;
    }
  }
}
</style>
